import { connect } from 'react-redux';
import LOANPIE from './LOANPIE';

import { getAnnualResults } from '../../selectors';
import { setSystemProduction } from '../../actions';

const mapStateToProps = state => ({
    annualResults: getAnnualResults(state),
    selectedFinancing: state.settings.selectedFinancing,
    doughnutSlider: state.settings.doughnutSlider,
    projectState: state.projectaddress.projectState,
    aFixedCharge: state.utility.aFixedCharge,
    sgipToggle: state.sgip.sgipToggle,
    resiToggle: state.tax.resiToggle,
    loanProvider: state.loan.loanProvider,
});

const combinedActions = {
    setSystemProduction,
};

export default connect(
    mapStateToProps,
    combinedActions,
)(LOANPIE);



// WEBPACK FOOTER //
// ./src/containers/Simulator/TabBar/Results/Graphs/LOANPIE/index.js